import React from 'react';

interface ArtWaveSvgProps {
  fill?: string;
}

const ArtWaveSvg: React.FC<ArtWaveSvgProps> = ({ fill = '#183344' }) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1440 400"
    preserveAspectRatio="xMinYMax slice"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_9279_118075)">
      <path
        d="M17.1 349.999L0 338.111V998H1440V86L1423 114.778C1406 132.555 1371.4 228.111 1337 222.222C1303 215.888 1268.6 279.222 1234 290.667C1200 302.555 1165.7 263.666 1131 287.332C1097 311.443 1069.31 290.088 1025.35 304.44C983.673 320.08 964.752 301.188 926 329.585C891 359.251 857.1 359.251 823 311.807C789 264.807 754.3 161.444 720 155.888C686 150.333 651.4 262.554 617 280.665C583 298.11 548.6 251.443 514 239.221C480 226.999 445.7 251.443 411 233.332C377 215.888 342.9 335.888 309 336.222C274 335.888 240 275.888 206 299.221C171 322.554 137.1 421.443 103 403.332C69 385.888 34.3 361.444 17.1 349.999Z"
        fill={fill}
      />
      <path
        d="M0 76.21L17.3375 94.3641C34.7764 111.839 69.9583 149.166 104.431 175.803C139.004 203.458 173.375 220.424 208.861 184.795C243.333 149.166 277.806 57.547 313.292 58.056C347.662 57.547 382.236 149.166 416.708 175.803C451.89 203.458 486.667 166.132 521.139 184.795C556.219 203.458 591.097 274.717 625.569 248.08C660.447 220.425 695.528 94.8731 730 103.356C764.776 111.839 799.958 178.055 834.43 249.823C869.004 322.27 903.375 322.27 938.861 276.969C978.152 233.608 997.335 216.647 1039.59 192.765C1084.16 170.848 1112.24 203.458 1146.71 166.641C1181.89 130.503 1216.67 21.9175 1251.14 3.76346C1286.22 -13.7119 1321.1 57.547 1355.57 67.2178C1390.45 76.21 1425.53 21.9175 1442.76 -5.22875L1460 -32.375"
        stroke="#38749D"
        strokeLinecap="round"
      />
      <circle cx="608.839" cy="254.049" r="7.60417" fill="#38749D" />
      <circle cx="443.573" cy="186.118" r="7.60417" fill="#38749D" />
      <circle cx="166.784" cy="204.368" r="7.60417" fill="#38749D" />
      <circle cx="893.745" cy="306.77" r="7.60417" fill="#38749D" />
      <circle cx="1116.8" cy="184.09" r="7.60417" fill="#38749D" />
      <circle cx="1365.2" cy="68.5065" r="7.60417" fill="#38749D" />
    </g>
    <defs>
      <clipPath id="clip0_9279_118075">
        <rect width="1440" height="400" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ArtWaveSvg;
